import React, {useEffect, useState} from "react"
import {FormattedMessage, useIntl} from "react-intl"


export function LandingHeaderAboutGedcom() {
    const [gedcomExcerpt, setGedcomExcerpt] = useState<string>()
    const intl = useIntl()

    useEffect(() => {
        fetch(`/data/gedcom/${intl.locale}/excerpt.ged`).then((response) => response.text()).then((text) => setGedcomExcerpt(text))
    }, [intl])

    return (
        <div className="about-gedcom">
            <p><FormattedMessage id="landing.slider.card1.practical"/>&nbsp;<span style={{ fontSize: 30 }}>👨‍💻</span></p>
            <p><FormattedMessage id="landing.slider.card1.visualization"/></p>
            <div id="gedcom-example">
                {/* CODE */}
                <div className="gedcom-code">{gedcomExcerpt}</div>
                {/* CHART */}
                <div className="gedcom-chart"><img src={`/assets/chart.svg`} alt=""/></div>
            </div>
        </div>
    )
}